<template>
    <q-dialog v-model="isOpen">
        <q-card style="width: 320px">
            <div class="q-pa-md">
                <div class="title">
                    <span v-if="type === 'add'">Add new group</span>
                    <span v-else>Edit group</span>
                </div>
                <q-form @submit.prevent="onSubmit">
                    <div class="mb-5">
                        <q-select v-model="selectedCompany"
                                  name="company_id"
                                  :options="companies"
                                  :option-label="company => company.name"
                                  :option-value="company => company"
                                  autofocus
                                  lazy-rules
                                  :rules="[val => !!val.id || 'Please select a company']"
                                  label="Company *"/>
                    </div>
                    <div class="mb-5">
                        <q-input v-model="name"
                                 name="name"
                                 type="text"
                                 lazy-rules
                                 :rules="[val => (val !== null && val !== '') || 'Please enter a name']"
                                 label="Name *"/>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <q-btn type="button" color="red" label="CLOSE" @click="close" :disable="isLoading"/>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="text-right">
                                <q-btn type="submit" color="primary" label="SAVE" :disable="isLoading"/>
                            </div>
                        </div>
                    </div>
                </q-form>
            </div>
        </q-card>
    </q-dialog>
</template>

<script>
import axios from "@/axios";

export default {
    name: "GroupFormModal",
    props: {
        open: Boolean,
        type: 'add' | 'edit',
        dataCompanies: Array,
        dataSelectedCompany: Object | null,
        dataId: String | null,
        dataName: {
            type: String,
            default: '',
            required: false
        },
        callback: Function,
    },
    data: () => ({
        id: null,
        name: '',
        isLoading: false,
    }),
    computed: {
        isOpen: {
            get() {
                return this.open;
            },
            set(value) {
                this.$emit("update:open", value);
            },
        },
        companies: {
            get() {
                return this.dataCompanies;
            },
            set(value) {
                this.$emit("update:dataCompanies", value);
            },
        },
        selectedCompany: {
            get() {
                return this.dataSelectedCompany;
            },
            set(value) {
                this.$emit("update:dataSelectedCompany", value);
            },
        },
    },
    methods: {
        close() {
            this.isOpen = false;
        },
        async onSubmit() {
            this.isLoading = true;
            try {
                if (this.type === 'add') {
                    await axios.put(`/company-vehicle-groups`, {
                        company_id: this.selectedCompany.id,
                        name: this.name,
                    });
                } else if (this.type === 'edit') {
                    await axios.patch(`/company-vehicle-group/${this.id}`, {
                        company_id: this.selectedCompany.id,
                        name: this.name,
                    });
                }
                this.callback();
                this.close();
                this.$q.notify({
                    message: 'Successfully saved',
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'positive'
                });
            } catch (e) {
                this.$q.notify({
                    message: e.response.data.message,
                    timeout: 250,
                    position: 'top-right',
                    progress: true,
                    type: 'negative'
                });
            } finally {
                this.isLoading = false;
            }
        }
    },
    watch: {
        open(value) {
            if (value) {
                this.id = this.dataId;
                this.name = this.dataName;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
